module.exports = {"130503001":"钢铁路街道","130503002":"中兴路街道","130503003":"达活泉街道","130503004":"张宽街道","130503005":"章村街道","130503006":"中华大街街道","130503007":"团结路街道","130503008":"泉西街道","130503100":"南大郭镇","130503101":"李村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130503.json
// module id = 133
// module chunks = 0